import { motion, useReducedMotion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';
import { Sparkles } from 'lucide-react';

interface Milestone {
  year: string;
  el: string;
  en: string;
}

const milestones: Milestone[] = [
  { year: '1963', el: 'Ίδρυση της TESCO.', en: 'Founding of TESCO.' },
  { year: '1964', el: 'Λανσάρισμα της 1ης συσκευασίας γάλακτος στην Ελλάδα.', en: 'Launch of the 1st milk packaging in Greece.' },
  { year: '1970', el: 'Πρωτοποριακές σήραγγες κατάψυξης παγωτού -40°C σε Άστυ & Έβγα.', en: 'Pioneering -40°C ice cream freezing tunnels at Asty & Evga.' },
  { year: '1972', el: 'Παράδοση πλήρους εξοπλισμού παραγωγής φέτας για τη ΔΩΔΩΝΗ.', en: 'Delivery of complete feta production equipment for DODONI.' },
  { year: '1974', el: 'Παράδοση της 1ης ελικοειδούς σήραγγας κατάψυξης πουλερικών στον Βοκτάς.', en: 'Delivery of the 1st spiral poultry freezing tunnel at Voktas.' },
  { year: '1977', el: 'Τοποθέτηση ελικοειδούς σήραγγας κατάψυξης πουλερικών για τη Βιομηχανία Μιμίκος.', en: 'Installation of a spiral poultry freezing tunnel for Mimikos Industries.' },
  { year: '1979', el: 'Παροχή σήραγγας κατάψυξης παγωτού για το πρωτοποριακό εργοστάσιο της ΔΕΛΤΑ.', en: 'Ice cream freezing tunnel supplied for the pioneering DELTA factory.' },
  { year: '1984', el: 'Προμήθεια και εγκατάσταση των πρώτων υπερσύγχρονων πλήρων γραμμών παραγωγής παγωτού στη ΔΕΛΤΑ.', en: 'Supply and installation of the first state-of-the-art complete ice cream production lines at DELTA.' },
  { year: '1987', el: 'Λανσάρισμα της χάρτινης Fresh Pack συσκευασίας γάλακτος της ΔΕΛΤΑ.', en: "Launch of DELTA's Fresh Pack carton milk packaging." },
  { year: '1988', el: 'Έργο επέκτασης και εκσυγχρονισμού του ψυχροστασίου του ΑΓΝΟ.', en: "Expansion and modernization project of AGNO's cold storage facility." },
  { year: '1989', el: 'Λανσάρισμα της πρωτοποριακής συσκευασίας του χυμού LIFE με το χαρακτηριστικό μαύρο χρώμα — συνεργασία TESCO, ΔΕΛΤΑ & ELOPAK.', en: 'Launch of the pioneering LIFE juice packaging in its iconic black design — a TESCO, DELTA & ELOPAK collaboration.' },
  { year: '1990', el: 'Παράδοση εξοπλισμού στη FROZA για ψυκτικές εγκαταστάσεις, με ψυγείο από panels πολυουρεθάνης.', en: 'Equipment delivery to FROZA for refrigeration facilities, including a polyurethane panel cold room.' },
  { year: '1992', el: 'Εγκατάσταση πλήρους γραμμής κατάψυξης λαχανικών στον Μπάρμπα Στάθη.', en: 'Installation of a complete vegetable freezing line at Barba Stathis.' },
  { year: '1993', el: 'Κατασκευή δύο νέων εργοστασίων ΔΕΛΤΑ σε Άγιο Στέφανο και Ταύρο. Εγκατάσταση ολοκληρωμένων ψυκτικών συγκροτημάτων για τις νέες γραμμές επεξεργασίας.', en: 'Construction of two new DELTA factories in Agios Stefanos and Tavros. Installation of integrated refrigeration units for the new processing lines.' },
  { year: '1994', el: 'Μετονομασία της ΤΕΣΚΟ σε TESCO ENGINEERING. Προμήθεια νέου εξοπλισμού στο εργοστάσιο παγωτού ΔΕΛΤΑ.', en: 'TESCO renamed to TESCO ENGINEERING. New equipment supplied to the DELTA ice cream factory.' },
  { year: '1995', el: 'Παροχή εξοπλισμού Ποιοτικού Ελέγχου σε 5 εργαστήρια ανάλυσης ποιότητας γάλακτος στην ΕΛΓΟ – ΔΗΜΗΤΡΑ.', en: 'Quality Control equipment supplied to 5 milk quality analysis labs at ELGO – DIMITRA.' },
  { year: '2004', el: 'Παροχή ψυκτικής εγκατάστασης για θαλάμους συντήρησης γαλακτοκομικών στη ΔΩΔΩΝΗ.', en: 'Refrigeration installation for dairy storage rooms at DODONI.' },
  { year: '2007', el: 'Εγκατάσταση καινοτόμου τούνελ ψύξης παλετών γιαούρτης στη VIVARTIA.', en: 'Installation of an innovative yogurt pallet cooling tunnel at VIVARTIA.' },
  { year: '2013', el: '50 χρόνια TESCO ENGINEERING. Εγκατάσταση γραμμών παραγωγής γιαουρτιού για λογαριασμό της ΔΩΔΩΝΗ.', en: '50 years of TESCO ENGINEERING. Installation of yogurt production lines for DODONI.' },
  { year: '2016', el: 'Παράδοση του 1ου turn-key project: ένα πλήρες εργοστάσιο παραγωγής Χαλουμιού στην Κύπρο, για τη ΔΩΔΩΝΗ.', en: 'Delivery of the 1st turn-key project: a complete Halloumi production plant in Cyprus, for DODONI.' },
  { year: '2019', el: 'Μετονομασία της TESCO ENGINEERING σε TESCO FOOD TECHNOLOGY.', en: 'TESCO ENGINEERING is renamed to TESCO FOOD TECHNOLOGY.' },
  { year: '2021', el: 'Η πρώτη χάρτινη συσκευασία μεταλλικού νερού Θεόνη. Αυτόματη γραμμή μορφοποίησης παγωτού μονής και διπλής επίστρωσης για την ΚΡΙ-ΚΡΙ. Σύγχρονη μονάδα συλλογής, αποθήκευσης, παστερίωσης και τυποποίησης νωπού γάλακτος στη Greek Family Farm.', en: 'The first carton packaging for Theoni mineral water. Automatic single & double-coated ice cream forming line for KRI-KRI. Modern raw milk collection, storage, pasteurization and standardization unit at Greek Family Farm.' },
  { year: '2024', el: 'Εγκατάσταση γραμμών επισυσκευασίας Buhmann και ρομποτικών συστημάτων Roboteh στα ΕΛΛΗΝΙΚΑ ΓΑΛΑΚΤΟΚΟΜΕΙΑ Α.Ε. Παράδοση εξοπλισμού θαλάμου επώασης γιαούρτης set 120 παλετοθέσεων με καινοτόμο τούνελ ταχείας ψύξης παλετών στην TYRBUL.', en: 'Installation of Buhmann secondary packaging lines and Roboteh robotic systems at HELLENIC DAIRIES S.A. Delivery of a 120-pallet set yogurt incubation chamber with innovative rapid pallet cooling tunnel at TYRBUL.' },
  { year: '2025', el: 'Κατασκευή υπερσύγχρονου τυροκομείου για τον ΕΑΣ Νάξου. Εγκατάσταση σύγχρονης γραμμής εμφιάλωσης γυάλινης φιάλης στο Ξινό Νερό.', en: 'Construction of a state-of-the-art cheese factory for EAS Naxos. Installation of a modern glass bottle filling line at Xino Nero.' },
];

export const HistoryTimeline = () => {
  const { language } = useLanguage();
  const shouldReduceMotion = useReducedMotion();

  return (
    <div className="relative w-full">
      <div className="overflow-x-auto pb-4 pt-2 horizontal-scroll">
        <div className="relative inline-flex items-stretch gap-5 px-8 py-16 min-w-full">
          {/* Horizontal track line */}
          <div
            aria-hidden
            className="absolute left-4 right-4 top-1/2 h-0.5 -translate-y-1/2 bg-gradient-to-r from-[#0077B6] via-[#003F72] to-[#0077B6] rounded-full"
          />

          {/* Glowing overlay on the line */}
          <motion.div
            aria-hidden
            animate={shouldReduceMotion ? {} : { opacity: [0.3, 0.7, 0.3] }}
            transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
            className="absolute left-4 right-4 top-1/2 h-0.5 -translate-y-1/2 bg-[#0077B6] rounded-full blur-sm pointer-events-none"
          />

          {milestones.map((m, idx) => {
            const isTop = idx % 2 === 0;
            return (
              <motion.div
                key={m.year}
                initial={shouldReduceMotion ? { opacity: 1 } : { opacity: 0, y: isTop ? -20 : 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1], delay: idx * 0.02 }}
                className="relative h-[26rem] w-80 flex-shrink-0"
              >
                {/* Card — alternates above/below the track */}
                <div
                  className={`absolute left-0 right-0 ${
                    isTop ? 'bottom-[calc(50%+10px)]' : 'top-[calc(50%+10px)]'
                  }`}
                >
                  <div
                    className={`group relative bg-white rounded-xl shadow-md hover:shadow-lg border border-[#003F72]/10 hover:border-[#0077B6]/40 transition-all duration-300 p-4 overflow-hidden ${
                      isTop ? 'hover:-translate-y-1' : 'hover:translate-y-1'
                    }`}
                  >
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-[#0077B6]/0 via-[#0077B6]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    <div className="flex items-center gap-1 mb-2">
                      <Sparkles className="h-3 w-3 text-[#0077B6]" />
                      <span className="text-xl font-bold bg-gradient-to-r from-[#0077B6] to-[#003F72] bg-clip-text text-transparent">
                        {m.year}
                      </span>
                    </div>
                    <p className="text-[#003F72]/80 text-xs leading-relaxed">
                      {language === 'el' ? m.el : m.en}
                    </p>
                  </div>
                </div>

                {/* Center dot (smaller icon) */}
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
                  <div className="relative">
                    <motion.div
                      aria-hidden
                      animate={shouldReduceMotion ? {} : { scale: [1, 1.8, 1], opacity: [0.6, 0, 0.6] }}
                      transition={{ duration: 2.5, repeat: Infinity, ease: 'easeOut' }}
                      className="absolute inset-0 bg-[#0077B6] rounded-full"
                    />
                    <div className="relative w-3 h-3 bg-white border-2 border-[#0077B6] rounded-full shadow" />
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>

      {/* Scroll hint for touch / mouse users */}
      <p className="text-center text-xs text-[#003F72]/50 mt-2">
        {language === 'el' ? 'Σύρετε οριζόντια για να δείτε όλα τα ορόσημα' : 'Scroll horizontally to see all milestones'}
      </p>
    </div>
  );
};
